import React from "react";
const SvgDsClose = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsClose;
